import { useEffect, useState } from "react";
import MESSAGES from "../../../../common/data/constants/messages";
import { ICustomer } from "../../../../common/data/dtos/customer";
import { IService } from "../../../../common/data/dtos/service";
import Badge from "../../../../components/bootstrap/Badge";
import Button from "../../../../components/bootstrap/Button";
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from "../../../../components/bootstrap/Card";
import { MoreActions } from "../../../../components/extras/MoreActions";
import { showSuccess, showWarning } from "../../../../components/extras/Notifications";
import PaginationButtons, { dataPagination, PER_COUNT } from "../../../../components/PaginationButtons";
import customerService from "../../../../services/customer-service";
import serviceService from "../../../../services/service-service";
import LoadingPage from "../../loading/LoadingPage";
import { ServicePriceModal } from "../../service-price/Common/ServicePriceModal";
import { ServiceModal } from "./ServiceModal";

export const CommonServiceList = () => {
	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(PER_COUNT['10']);

	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isModalOpened, setIsModalOpened] = useState(false);
	const [isModalPriceOpened, setIsModalPriceOpened] = useState(false);

	const [services, setServices] = useState<IService[]>([]);
	const [customers, setCustomers] = useState<ICustomer[]>([]);
	const [selectedService, setSelectedService] = useState<IService | null>(null);

	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {

		setIsLoading(true);

		try {

			const [servicesResponse, customersResponse] = await Promise.all([
				serviceService.getServices(),
				customerService.getCustomers()
			]);

			if (servicesResponse.error) {
				showWarning(servicesResponse.error);
				return;
			}

			if (customersResponse.error) {
				showWarning(customersResponse.error);
				return;
			}

			setServices(servicesResponse.services || []);
			setCustomers(customersResponse.customers || []);
		} catch (error) {
			showWarning('Erro ao carregar dados');
		} finally {
			setIsLoading(false);
		}
	}

	const fetchServices = async () => {
		setIsLoading(true);

		const response = await serviceService.getServices();

		setIsLoading(false);

		if (response.error) {
			showWarning(response.error);
			return;
		}

		setServices(response.services || []);
	};

	const toggleModal = (setter: React.Dispatch<React.SetStateAction<boolean>>, isVisible: boolean) => {
		setter(isVisible);
	};

	const handleAddClick = () => {
		toggleModal(setIsModalOpened, true);
	};

	const onModalClose = () => {
		toggleModal(setIsModalOpened, false);
		setSelectedService(null);
	};

	const onAfterSubmit = async () => {
		await fetchServices();
		onModalClose();
		onPriceModalClose();
	};

	const handleDeleteClick = async (service: IService) => {
		if (!service.id) {
			showWarning(MESSAGES.ACTION.DELETE_ID_ERROR);
			return;
		}

		setIsLoading(true);

		const response = await serviceService.deleteService(service.id);

		setIsLoading(false);

		if (response.error) {
			showWarning(response.error);
			return;
		}

		showSuccess(MESSAGES.ACTION.DELETED);
		await fetchServices();
	};

	const handleEditClick = (Service: IService) => {
		setSelectedService(Service);
		toggleModal(setIsModalOpened, true);
	};

	const handlePriceClick = async (service: IService | null) => {
		setSelectedService(service);
		toggleModal(setIsModalPriceOpened, true);
	};

	const onPriceModalClose = () => {
		toggleModal(setIsModalPriceOpened, false);
		setSelectedService(null);
	};

	if (isLoading) {
		return <LoadingPage />;
	}
	return (
		<>
			<Card style={{ minHeight: 600 }}>
				<CardHeader borderSize={1}>
					<CardLabel icon='DesignServices' iconColor='primary'>
						<CardTitle tag='div' className='h5'>
							Serviços
						</CardTitle>
					</CardLabel>
					<CardActions>
						<Button color='light' icon='AddCircle' onClick={handleAddClick}>
							Adicionar
						</Button>
					</CardActions>
				</CardHeader>
				<CardBody className='table-responsive'>
					<table className='table table-modern table-hover'>
						<thead>
							<tr>
								<th>Descrição</th>
								<th>Unidade</th>
								<th>Situação</th>
								<td aria-labelledby='Actions' />
							</tr>
						</thead>
						<tbody>
							{dataPagination(services, currentPage, perPage).map((item: IService) => (
								<tr key={item.id}>
									<td>{item.description}</td>
									<td>{item.unit}</td>
									<td>
										{item.status ? (
											<h5>
												<Badge color='success' className='align-items-center justify-content-center'>
													Ativo
												</Badge>
											</h5>
										) : (
											<h5>
												<Badge color='danger' className='align-items-center justify-content-center'>
													Inativo
												</Badge>
											</h5>
										)}
									</td>

									<MoreActions
										id={item.id}
										showEdit={true}
										showDelete={true}
										onEditClick={() => handleEditClick(item)}
										onDeleteClick={() => handleDeleteClick(item)}
										customActions={[
											{
												label: 'Preço',
												icon: 'AttachMoney',
												onClickAction: () => handlePriceClick(item),
											}
										]}
									/>
								</tr>
							))}
						</tbody>
					</table>
				</CardBody>
				<PaginationButtons data={services} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
			</Card>

			<ServiceModal isModalOpened={isModalOpened} onModalClose={onModalClose} onAfterSubmit={onAfterSubmit} selectedService={selectedService} />
			<ServicePriceModal isModalOpened={isModalPriceOpened} onModalClose={onPriceModalClose} onAfterSubmit={onAfterSubmit} selectedService={selectedService} customers={customers} />
		</>
	);
};